import Axios from '@/http'

export default {
  // 获取综合态势数据
  getZhtssjApi(params) {
    return new Promise((resolve, reject) => {
      Axios.post('dutyTask/zhtssj', params).then((res) => {
        return resolve(res)
      })
    })
  },

  // 进行中未归队的任务(不分页)
  getLeaveTeamTask(params) {
    return new Promise((resolve, reject) => {
      Axios.post('dutyTask/leaveTeamTaskFindAll', params).then((res) => {
        return resolve(res)
      })
    })
  },

  /* 其他设置(查询) */
  otherConfig() {
    return new Promise((resolve, reject) => {
      Axios.post('dutyTask/otherConfig').then((res) => {
        resolve(res)
      })
    })
  }
}
